module.exports = __webpack_public_path__ + "static/media/lucky_number_person.ab369e98.png";